import React, { Fragment, useState, useEffect } from 'react';
import axios from "axios";
import styles from "./TeacherModal.module.sass";
import Button from '../../Button';
import ModalContent from './ModalContent';
import Spinner from "../../Spinner";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const TeacherList = ({ schoolId }) => {
  const [matchCount, setMatchCount] = useState({});
  const [data, setData] = useState();

  const handleUpdateClick = () => {
    confirmAlert({
      title: 'Confirm Update',
      message: "Are you sure? This will try to find matching student records for each teacher.",
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            setData();

            axios
              .post(`/api/v1/educators/match_teacher_to_student?school_id=${schoolId}`)
              .then((data) => {
                console.log(data.data.data)
                setMatchCount(data.data.data)
                getTeachers()
              })
          }
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  }

  const getTeachers = () => {
    axios
      .get(`/api/v1/students/students_per_teacher?school_id=${schoolId}`)
      .then((data) => {
        setData(data.data.data)
      })
  }

  useEffect(() => {
    getTeachers();
  }, [schoolId])

  return (
    <Fragment>
      {!data && <Spinner color="blue" />}
      {data && (
        <>
          <a href={`/schools/${schoolId}/print_teachers`} target="_blank">Print Teacher List</a>{' | '}
          <a href={`/schools/${schoolId}/print_teachers.csv`} target="_blank">Download CSV Teacher List</a>
          {matchCount.matched_teachers && (
            <p>
              Matched teachers: {matchCount.matched_teachers}
            </p>
          )}

          {matchCount.unmatched_teachers && (
            <p>
              Unmatched teachers: {matchCount.unmatched_teachers}
            </p>
          )}
          <hr />
          <ModalContent data={data} schoolId={schoolId} />
        </>
      )}
    </Fragment>
  )
}

export default TeacherList;
